export const TEST_ID = 'stateComplianceModalApplicationDetails';

export const COUNTY_FALLBACK = '—';
